import { useQuery } from "@tanstack/react-query";
import { getAllTargets, getTargetList, getTargets } from "../../api";
import { getPorts, getScannerConfigs, getScanners } from "../../gvmFunctions";

export const useGetTargets = (page, isScanned) => {
  const query = useQuery({
    queryKey: ["targets", page, isScanned],
    queryFn: () => getTargets(page, isScanned),
  });
  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};

export const useGetTargetList = (id, page) => {
  const query = useQuery({
    queryKey: ["targets", id, page],
    queryFn: () => getTargetList(id, page),
  });
  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};

export const useGetAllTargets = () => {
  const query = useQuery({
    queryKey: ["targets"],
    queryFn: () => getAllTargets(),
  });
  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};

export const useGetPorts = () => {
  const query = useQuery({
    queryKey: ["ports"],
    queryFn: () => getPorts(),
  });
  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};
export const useGetScanners = () => {
  const query = useQuery({
    queryKey: ["scanners"],
    queryFn: () => getScanners(),
  });
  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};
export const useGetConfigs = () => {
  const query = useQuery({
    queryKey: ["configs"],
    queryFn: () => getScannerConfigs(),
  });
  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};
